import { render, staticRenderFns } from "./BDImg.vue?vue&type=template&id=35ebf44d&"
import script from "./BDImg.vue?vue&type=script&lang=js&"
export * from "./BDImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports